// extracted by mini-css-extract-plugin
module.exports = {"mobileGate":"_3EWu5K9DznEdReTj4mApgI","content":"a2L9kYr8QYvyBZljeooDf","logo":"_3ck57dM4zh92iT2eFZRrup","title":"XOK9oL5oF4uvOCsbLUUQE"};